export default {
  isFetchingVacancy: true,
  isInviteRequest: false,
  message: undefined,
  data: {},
};
